import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import httpClient from '@api/httpClient';

import { store } from '@app/redux/store';

import { RefreshTokenResponse } from '../auth/refreshToken';
import { UserUpdateResponse } from '../users/update';

interface ToggleMFAPayload {
	enable_email_mfa?: boolean;
	enable_phone_mfa?: boolean;
	mfa_enabled: boolean;
}

type ToggleMFAResponse = UserUpdateResponse & RefreshTokenResponse;

const toggleMFA = createAsyncThunk<ToggleMFAResponse, ToggleMFAPayload, { rejectValue: AxiosError }>(
	ACCOUNT_CLIENT_API_ENDPOINTS.MFA.TOGGLE_MFA(),
	async ({ ...settings }, { rejectWithValue }) => {
		const { first_name, last_name, phone, email } = store.getState().auth.currentUser || {};
		const branch = store.getState().branchEnvironment.variables.branch_id;
		try {
			const settingsResponse = await httpClient.request<UserUpdateResponse>({
				data: { branch, first_name, last_name, phone, email, ...settings },
				url: ACCOUNT_CLIENT_API_ENDPOINTS.USERS.UPDATE(),
				method: HTTP_METHODS_ENUM.PUT,
			});
			const refreshTokenResponse = await httpClient.request<RefreshTokenResponse>({
				data: { refresh_token: store.getState().auth.tokens?.refresh_token },
				url: ACCOUNT_CLIENT_API_ENDPOINTS.AUTH.REFRESH_TOKEN(),
				method: HTTP_METHODS_ENUM.POST,
			});
			const mergedResponses = { ...settingsResponse.data, ...refreshTokenResponse.data } as ToggleMFAResponse;
			return mergedResponses;
		} catch (e: unknown) {
			return rejectWithValue(e as AxiosError);
		}
	},
);

export default toggleMFA;
